import React, { useState } from 'react';
import {
  Box,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import { 
  FilterList as FilterIcon,
  ExpandMore as ExpandMoreIcon
} from '@mui/icons-material';
import { 
  TARGET_TYPES, 
  GOAL_STATUSES,
  MONTHS,
  QUARTERS
} from '../../constants/goalsConstants';

const GoalsFilters = ({ filters, onFilterChange, employees, isAdmin }) => {
  const [expanded, setExpanded] = useState(false);
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - 2 + i);

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    onFilterChange({
      ...filters,
      [name]: value
    });
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    onFilterChange({
      ...filters,
      [name]: checked
    });
  };

  const handleResetFilters = () => {
    onFilterChange({
      year: 'all',
      month: 'all',
      quarter: 'all',
      targetType: 'all',
      assignedTo: 'all',
      status: 'all',
      onlyCompanyGoals: false,
      onlyIndividualGoals: false
    });
  };

  return (
    <Accordion 
      expanded={expanded} 
      onChange={() => setExpanded(!expanded)}
      sx={{ mb: 3 }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <FilterIcon sx={{ mr: 1 }} />
          <Typography>Filtry</Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          {/* Filtr roku */}
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Rok</InputLabel>
              <Select
                name="year"
                value={filters.year}
                onChange={handleFilterChange}
                label="Rok"
              >
                <MenuItem value="all">Wszystkie lata</MenuItem>
                {years.map(year => (
                  <MenuItem key={year} value={year}>{year}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Filtr miesiąca */}
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Miesiąc</InputLabel>
              <Select
                name="month"
                value={filters.month}
                onChange={handleFilterChange}
                label="Miesiąc"
              >
                <MenuItem value="all">Wszystkie miesiące</MenuItem>
                {Object.entries(MONTHS).map(([key, value]) => (
                  <MenuItem key={key} value={parseInt(key)}>{value}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Filtr kwartału */}
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Kwartał</InputLabel>
              <Select
                name="quarter"
                value={filters.quarter}
                onChange={handleFilterChange}
                label="Kwartał"
              >
                <MenuItem value="all">Wszystkie kwartały</MenuItem>
                {Object.entries(QUARTERS).map(([key, value]) => (
                  <MenuItem key={key} value={parseInt(key)}>{value}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Filtr typu celu */}
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Typ celu</InputLabel>
              <Select
                name="targetType"
                value={filters.targetType}
                onChange={handleFilterChange}
                label="Typ celu"
              >
                <MenuItem value="all">Wszystkie typy</MenuItem>
                {Object.entries(TARGET_TYPES).map(([key, value]) => (
                  <MenuItem key={key} value={key}>{value}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Filtr statusu */}
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Status</InputLabel>
              <Select
                name="status"
                value={filters.status}
                onChange={handleFilterChange}
                label="Status"
              >
                <MenuItem value="all">Wszystkie statusy</MenuItem>
                {Object.entries(GOAL_STATUSES).map(([key, value]) => (
                  <MenuItem key={key} value={key}>{value}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Filtr przypisanego pracownika (tylko dla admina) */}
          {isAdmin && (
            <Grid item xs={12} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Przypisane do</InputLabel>
                <Select
                  name="assignedTo"
                  value={filters.assignedTo}
                  onChange={handleFilterChange}
                  label="Przypisane do"
                >
                  <MenuItem value="all">Wszyscy</MenuItem>
                  <MenuItem value="company">Cała firma</MenuItem>
                  {employees.map(employee => (
                    <MenuItem key={employee.id} value={employee.id}>
                      {`${employee.firstName || ''} ${employee.lastName || ''}`.trim() || employee.id}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}

          {/* Filtry dodatkowe */}
          <Grid item xs={12} md={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.onlyCompanyGoals}
                  onChange={handleCheckboxChange}
                  name="onlyCompanyGoals"
                />
              }
              label="Tylko cele firmowe"
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.onlyIndividualGoals}
                  onChange={handleCheckboxChange}
                  name="onlyIndividualGoals"
                />
              }
              label="Tylko cele indywidualne"
            />
          </Grid>

          {/* Przycisk resetowania filtrów */}
          <Grid item xs={12} md={4}>
            <Button 
              variant="outlined" 
              onClick={handleResetFilters}
              fullWidth
            >
              Resetuj filtry
            </Button>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default GoalsFilters;
